import { Box, Grid, Link, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LoginForm from './components/LoginForm';
import ForgotPassword from './components/ForgotPassword';
import logo from '../../assets/images/LogoOrderly.jpg';
import logomark from '../../assets/images/Logomark.jpg';
import ImageCarousel from './components/ImageCarousel';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import ActivateAccount from './components/ActivateAccount';

const LoginPage = () => {
  const { t } = useTranslation('authentication');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const currentYear = new Date().getFullYear();
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showAccountActivation, setShowAccountActivation] = useState(false);

  const showLogin = () => {
    setShowForgotPassword(false);
    setShowAccountActivation(false);
  };

  const showPassword = () => {
    setShowForgotPassword(true);
    setShowAccountActivation(false);
  };

  const showActivation = () => {
    setShowForgotPassword(false);
    setShowAccountActivation(true);
  };

  useEffect(() => {
    if (window.location.pathname.toLocaleLowerCase().indexOf('activ') > -1) {
      showActivation();
    }
  }, []);

  const renderActionArea = () => {
    if (showForgotPassword) {
      return <ForgotPassword switchDisplay={showLogin} />;
    }

    if (showAccountActivation) {
      return <ActivateAccount switchDisplay={showLogin} />;
    }


    return <LoginForm switchDisplay={showPassword} />;
  };

  return (
    <Grid container
      sx={{ display: 'flex', height: '100vh', width: '100vw', flexDirection: 'row', justifyContent: 'space-between' }}>
      <Grid item
        lg={5}
        md={5}
        xs={12}
        sx={{ padding: isMobile ? '48px' : '32px', display: 'flex', flexDirection: 'column', justifyContent: isMobile ? 'none' : 'space-between' }}
      >
        <Box
          sx={{ display: 'flex', alignContent: 'left' }}>
          {!isMobile && (<img src={logo}
            style={{ width: '135px', height: '35px' }}
            alt='' />)}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>{isMobile && (<img src={logomark}
          style={{ width: '40px', height: '40px' }}
          alt='' />)}</Box>
        <Grid sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBlock: 'auto' }} >
          {renderActionArea()}
        </Grid>
        <Box
          sx={{ display: isMobile ? 'none' : 'flex', flexDirection: 'row' }}
        >
          <Typography variant="textSM"
            sx={{ paddingRight: '62px' }}>{`${t('copyright')} ${currentYear}`}</Typography>
          <Link variant="textSM"
            href='https://www.orderly.io/legal/privacy-policy'>{t('privacyPolicy')}</Link>
        </Box>
      </Grid>
      <Grid item
        lg={7}
        md={7}
        sx={{ display: isMobile ? 'none' : 'flex' }} >
        <ImageCarousel />
      </Grid>
    </Grid>
  );
};

export default LoginPage;